import { Controller } from "stimulus";

export default class extends Controller {
  connect(){
    this.loadedITB = false;
    const observer = new IntersectionObserver( (changes)=> {
      for (const change of changes) {
        if (this.loadedITB === true){
          return   
        }
        if (change.isIntersecting === false) {
          return
        }
        this.loadedITB = true

        window.itb_widget = window.itb_widget || {
              init:t => {
              const e = document.createElement("script");
              e.async=!0 , e.type="text/javascript",
              e.src="https://app.intotheblock.com/widget.js",
              e.onload=function() {
              window.itbWidgetInit(t.apiKey)
            },
            document.getElementsByTagName("head")[0].appendChild(e)
          }
        };
        window.itb_widget.init({
          apiKey: "B9iEbZYamzaklVNH5XIP17K4nPCVujZJ37PeWhdX"      // Initialize the widget with your api keys
        })

      }
    });
    observer.observe(document.querySelector('#into-the-block-widget'),{
      delay: 100
    });
  }
}
